import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { grey } from "@mui/material/colors";

const InventorySnapshotReport = () => {
	return (
		<Stack
			width="100%"
			margin="auto"
			height="100vh"
			alignItems="stretch"
			sx={{
				backgroundColor: grey[200],
				padding: 2,
				boxSizing: "border-box",
			}}
		>
			<Box
				sx={{
					flex: 1,
					minHeight: 0,
					width: "100%",
					borderRadius: 1,
					overflow: "hidden",
					boxShadow: 2,
				}}
			>
				<iframe
					title="Inventory Snapshot Report"
					width="100%"
					height="100%"
					src="https://datastudio.google.com/embed/reporting/dd8bec76-d3e4-4a28-8c3b-4daa8be724c9/page/p_0hk22beqsd"
					frameBorder="0"
					style={{
						border: 0,
						display: "block",
						minHeight: "100%",
					}}
					allowFullScreen
					sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
				/>
			</Box>
		</Stack>
	);
};

export default InventorySnapshotReport;
